import { render, staticRenderFns } from "./InspectedReceivedBy.vue?vue&type=template&id=ada4e5fe"
import script from "./InspectedReceivedBy.vue?vue&type=script&lang=js"
export * from "./InspectedReceivedBy.vue?vue&type=script&lang=js"
import style0 from "./InspectedReceivedBy.vue?vue&type=style&index=0&id=ada4e5fe&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports